module.exports = __webpack_public_path__ + "media/images/vp/icon.arrow.left.gray-e09b0a5d8d246ad97bd7207971b231ba.svg";